import React from "react";
import VisibleHook from "../../../../tool/visibleHook";
import styles from "./index.module.scss";
import { classNames } from "../../../../tool";

const SencondTabsModal = (props) => {
  const { visible, handleHide, list, onClick, activeIndex } = props;
  const { containerVisible, contentVisible } = VisibleHook({ visible });

  return (
    <div
      className={classNames(
        styles.container,
        containerVisible ? styles.showMask : ""
      )}
      onClick={handleHide}
    >
      <div
        className={classNames(
          styles.content,
          (visible ? contentVisible : visible) ? styles.show : ""
        )}
      >
        <div
          className={classNames(
            styles.innerContent,
            (visible ? contentVisible : visible) ? styles.show : ""
          )}
        >
          <div className={styles.list}>
            {list.map((item, index) => {
              return (
                <div
                  className={classNames(
                    styles.navItem,
                    activeIndex === index ? styles.active : ""
                  )}
                  key={index}
                  onClick={() => {
                    handleHide();
                    onClick(index);
                  }}
                >
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SencondTabsModal;
